import { useEffect, useRef, useState } from 'react';

function VisiblePageRow({ children }) {
    const wrapRef = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = wrapRef.current;
        if (!el) {
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true);
                observer.disconnect();
            }
        }, { root: null, rootMargin: '300px' });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <div ref={wrapRef} style={inView ? undefined : { minHeight: 480 }}>
            {inView ? children : null}
        </div>
    );
}

export default VisiblePageRow;
